module.exports = __webpack_public_path__ + "static/media/jcb.d075213a.svg";


//////////////////
// WEBPACK FOOTER
// ./~/payment-icons/min/single/jcb.svg
// module id = 493
// module chunks = 0